import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import GetStarted from '@/pages/get-started/get-started'
import Invisalign from '@/pages/invisalign/invisalign'
// import PageNotFound from '@/pages/404/404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      linkName: 'HOME',
      navigation: true,
      mobile: true,
      component: Home
    },
    {
      path: '/get-started',
      name: 'get-started',
      linkName: 'GET STARTED',
      navigation: false,
      component: GetStarted
    },
    {
      path: '/invisalign',
      name: 'Invisalign',
      linkName: 'INVISALIGN',
      navigation: false,
      component: Invisalign
    },
    {
      path: '/*',
      navigation: false,
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js